import axios from '@/libs/api.request'

export const fetchAccounts = () => {
  return axios.request({
    url: '/v1/api/accounts',
    method: 'get'
  })
}

export const fetchAccount = (id) => {
  return axios.request({
    url: '/v1/api/accounts/' + id,
    method: 'get'
  })
}

export const getAppleID = (id) => {
  return axios.request({
    url: `/v1/api/appleid/${id}`,
    method: 'get'
  })
}

export const editAccounts = (data) => {
  return axios.request({
    url: '/v1/api/accounts/' + data._id,
    data,
    method: 'put'
  })
}

export const updateAccountsUuid = (id) => {
  return axios.request({
    url: '/v1/api/accounts/uuid/' + id,
    method: 'put'
  })
}

export const updateAccountsSubscription = (id) => {
  return axios.request({
    url: '/v1/api/accounts/subscription/' + id,
    method: 'put'
  })
}

export const addAccount = (data) => {
  return axios.request({
    url: '/v1/api/accounts',
    data,
    method: 'post'
  })
}

export const delAccount = (id) => {
  return axios.request({
    url: '/v1/api/accounts/' + id,
    method: 'delete'
  })
}
